const TwitterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M8.66084 19C15.4536 19 19.1683 13.6143 19.1683 8.9443C19.1683 8.79129 19.1651 8.63906 19.1577 8.48741C19.8787 7.98859 20.5056 7.36595 21 6.6575C20.3383 6.93884 19.6263 7.1283 18.8793 7.21372C19.6417 6.77623 20.2272 6.08384 20.5033 5.25862C19.7897 5.66359 18.9994 5.95786 18.1584 6.11656C17.4843 5.42966 16.5245 5 15.4626 5C13.4229 5 11.769 6.58285 11.769 8.53385C11.769 8.81127 11.8015 9.08086 11.8646 9.33967C8.79555 9.19214 6.07394 7.78562 4.25271 5.64733C3.93518 6.16946 3.75236 6.77642 3.75236 7.42356C3.75236 8.64964 4.40441 9.7321 5.39589 10.3655C4.79011 10.3477 4.22098 10.1882 3.72329 9.92332C3.72247 9.93802 3.72247 9.95291 3.72247 9.96839C3.72247 11.6802 4.99566 13.1092 6.68525 13.4331C6.37509 13.514 6.04876 13.5575 5.71178 13.5575C5.47389 13.5575 5.24255 13.5348 5.01756 13.4938C5.48761 14.8978 6.85107 15.9197 8.46758 15.9485C7.20341 16.8966 5.61106 17.4614 3.88093 17.4614C3.58306 17.4614 3.28907 17.4452 3 17.4124C4.63432 18.4148 6.5749 19 8.66084 19Z"
        fill="#0E0E0E"
      />
    </svg>
  );
};

export default TwitterIcon;
